import { Component, OnInit } from '@angular/core';
import { Course } from '../../core/models/course';
import { BaseComponent } from 'src/app/components/base/base.component';
import { BaseService } from 'src/app/core/services/base.service';
import { AlertService } from 'src/app/core/services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { Teacher } from '../../core/models/teacher';
import { TeacherService } from '../../core/services/teacher.service';

@Component({
  selector: 'app-teacher-view-profile',
  templateUrl: './teacher-view-profile.component.html',
  styleUrls: ['./teacher-view-profile.component.scss']
})
export class TeacherViewProfileComponent  extends BaseComponent implements OnInit {

  teacher = {} as Teacher;
  p: number = 1;

  constructor(
    public baseService:BaseService,
    private alertService: AlertService,
    private route :ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private teacherService: TeacherService
  ) { super() }

  ngOnInit(): void {
    this.loadData();
  }

  loadData(){
    this.route.data.pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      data=>{
        this.teacher = data.teacher.result.returnData;
        // console.log(this.teacher)
      });
  }

  openDetail(id) {
    this.router.navigate(['/course-details/edit', id]);
  }
}
